var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuth)?_c('AppHeader',{attrs:{"isBoss":_vm.isBoss}}):_vm._e(),_c('AppPage',{attrs:{"isBoss":_vm.isBoss}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }